import React, { useState } from "react";
import "./certificate.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import html2pdf from "html2pdf.js";
import PLButton from "../common/button";

export const PrintableCertificate = ({
  courseStatus,
  userName,
  state,
  completedDate,
  className,
  hideIcon,
}: {
  courseStatus: string;
  userName: string;
  state: string;
  completedDate;
  className?: string;
  hideIcon?: boolean;
}) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const isSafariBrowser = isSafari();

  const print = async () => {
    if (isGenerating) return;
    setIsGenerating(true);

    try {
      const element = document.getElementById(completedDate);
      if (!element) {
        throw new Error("Unable to locate certificate content.");
      }

      const pdfFormat = [1250, 702];
      const pdfUnit = "px";
      const opt = {
        margin: 0,
        padding: 0,
        filename: "certificate.pdf",
        image: { type: "jpeg", quality: 0.98 },
        jsPDF: {
          unit: pdfUnit,
          format: pdfFormat,
          orientation: "landscape",
        },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };

      if (!isSafariBrowser) {
        await html2pdf(element, opt);
        return;
      }

      await (html2pdf() as any).set(opt).from(element).save();
    } catch (error) {
      console.error("Error generating certificate:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <div className="cert-container">
        <Certificate
          userName={userName}
          state={state}
          completedDate={completedDate}
        />
      </div>
      {courseStatus === "pass" ? (
        <PLButton size="lg" onClick={() => print()} className={className}>
          {!hideIcon && !isGenerating ? (
            <FontAwesomeIcon
              icon="certificate"
              size={"2x"}
              color="white"
              style={{ marginRight: 5 }}
            />
          ) : null}
          {isGenerating ? (
            <FontAwesomeIcon
              icon="spinner"
              size={"1x"}
              color="white"
              style={{ marginRight: 5 }}
              spin
            />
          ) : null}
          <div>
            {isGenerating
              ? isSafariBrowser
                ? "Downloading..."
                : "Printing..."
              : isSafariBrowser
                ? "Download Certificate"
                : "Print Certificate"}
          </div>{" "}
        </PLButton>
      ) : null}
    </>
  );
};

const isSafari = () => {
  if (typeof window === "undefined") return false;
  const userAgent = window.navigator.userAgent;
  return /Safari/i.test(userAgent) && !/Chrome|CriOS|Chromium|Android|FxiOS|Firefox|EdgiOS|Edg/i.test(userAgent);
};

const Certificate = ({ userName, state, completedDate }) => {
  return (
    <div id={completedDate} className="centered-pdf">
      <div>
        <div>
          <div className={"bg-certificate bg-certificate-playsafely"}></div>
          <div
            style={{
              position: "absolute",
              left: "50%",
              top: 220,
              transform: "translateX(-50%)",
              textAlign: "center",
            }}
            className="cls_003"
          >
            <span className="cls_003">{userName}</span>
          </div>
          <div
            style={{
              position: "absolute",
              left: "50%",
              top: 365,
              transform: "translateX(-50%)",
              textAlign: "center",
            }}
            className="cls_003"
          >
            <span className="cls_003">{completedDate}</span>
          </div>
          {/*<div style={{position: 'absolute', left: 773, top: 491}} className="cls_005">*/}
          {/*    <span className="cls_005">Date</span>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};

export default Certificate;
